import { useCallback, ChangeEventHandler } from 'react';
import { IModalOptions } from './useModal.types';
import { useBoolean } from '../useBoolean';

export const useModalCheckboxState = (
  createModalOptions: (modalCheckboxState: {
    isChecked: boolean;
    resetCheckbox: () => void;
    handleCheckboxChange: ChangeEventHandler<HTMLInputElement>;
  }) => IModalOptions,
) => {
  const { value: isChecked, setFalse: resetCheckbox, set } = useBoolean(false);

  const handleCheckboxChange = useCallback((event) => set(event.target.checked), []);

  return createModalOptions({ isChecked, resetCheckbox, handleCheckboxChange });
};
